import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EnvService } from "src/app/services/env.service";
import { DpGetEnums, DpGetEnumsSuccess, DpSendCommit, DpSendCommitSuccess, DpSendValidate, DpSendValidateSuccess } from "./digital-payment.action";
import { catchError, map, mergeMap, of } from "rxjs";
import { langSpecificEnums } from "../utils";
import { Labels } from "src/app/app.models";
import { GFFP_FIELDS_CATEGORY } from "src/app/gffp/gffp.models";

// Todo: Remove #may6 - mock data response
const mockSendValidateRes = {
  "transactionId": "00000000-0000-0000-0000-000000000000",
  "readyForCommit": true,
  "cashInWalletFeeEnabled": false,
  "cashOutWalletFeeEnabled": false,
  "sendAmountDetails": {
    "promotionDetails": [
      {
        "code": "SDF0FEECASHOUT",
        "discount": {
          "value": 4,
          "currencyCode": "USDC"
        }
      }
    ],
    "fxRate": "1.1000",
    "amount": {
      "value": 7.77,
      "currencyCode": "USDC"
    },
    "fees": {
      "value": 4.44,
      "currencyCode": "USDC"
    },
    "taxes": {
      "value": 0,
      "currencyCode": "USDC"
    },
    "totalAmount": {
      "value": 11.00,
      "currencyCode": "USDC"
    },
    "partnerFees": {
      "value": 3.23,
      "currencyCode": "USD"
    }
  },
  "payoutAmountDetails": {
    "fxRate": 1.0,
    "fxRateEstimated": false,
    "amount": {
      "value": 7.77,
      "currencyCode": "USD"
    },
    "fees": {
      "value": 0,
      "currencyCode": "USD"
    },
    "taxes": {
      "value": 0,
      "currencyCode": "USD"
    },
    "totalAmount": {
      "value": 7.77,
      "currencyCode": "USD"
    }
  }
}

const mockSendCommitRes = {
  "transactionId": "00000000-0000-0000-0000-000000000000",
  "transactionCryptoNetworkInstructions": {
    "accountAddress": "GAYF33NNNMI2Z6VNRFXQ64D4E4SF77PM46NW3ZUZEEU5X7FCHAZCMHKU",
    "operationMemo": "1554302959099413281"
  },
  "sep24TransactionResponse": {
    "withdraw_anchor_account": "GAYF33NNNMI2Z6VNRFXQ64D4E4SF77PM46NW3ZUZEEU5X7FCHAZCMHKU",
    "withdraw_memo": "1554302959099413281",
    "withdraw_memo_type": "id",
    "id": "00000000-0000-0000-0000-000000000000",
    "kind": "withdrawal",
    "status": "pending_user_transfer_start",
    "more_info_url": "",
    "amount_in": "10.00",
    "amount_in_asset": "USDC",
    "amount_out": "7.00",
    "amount_out_asset": "USD",
    "amount_fee": "3.00",
    "amount_fee_asset": "USD",
    "started_at": "2024-10-08T21:34:35Z",
    "stellar_transaction_id": "",
    "external_transaction_id": "51800846",
    "refunded": false,
    "from": "GC62A74DHVCCSVC742XG2FNAJYJ5WMX6H3GZCCGK3W3VW7JMIXQEJRLF",
    "to": "GAYF33NNNMI2Z6VNRFXQ64D4E4SF77PM46NW3ZUZEEU5X7FCHAZCMHKU"
  },
  "referenceNumber": "51800846"
}

@Injectable()
export class DigitalPaymentEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private envService: EnvService,
    private store: Store
  ) {}

  private enumUrl(endpoint: string): string {
    // TODO:TIM Requirements changed, so this can probably be refactored into a single string value, and just interpolate the v2 or v3
    return endpoint === 'v3'
      ? `${this.envService.apiUrl}/v3/reference-data/enumerations?`
      : `${this.envService.apiUrl}/v2/reference-data/enumerations?`;
  }

  private sendValidateUrl(endpoint: string): string {
    // TODO:TIM Requirements changed, so this can probably be refactored into a single string value, and just interpolate the v2 or v3
    return endpoint === 'v3'
      ? `${this.envService.apiUrl}/v3/transactions/`
      : `${this.envService.apiUrl}/v2/transactions/`;
  }

  public dpGetEnumerations$ = createEffect(() => 
    this.actions$.pipe(
      ofType(DpGetEnums),
      mergeMap(({getEnumRequest, endpoint, sendValidatePayload, transactionId, cmsLabels}) => {
        return this.http.get(`${this.enumUrl(endpoint)}userLanguage=${getEnumRequest.userLanguage}&targetAudience=CUSTOMER_FACING&transactingCountryCode=${getEnumRequest.countryCode}`)
          .pipe(
            map((getEnumsResponse: any) => {
              const labels: Labels = cmsLabels;
              const enumsObj = labels?.stellar?.enumsObj;

              if (getEnumsResponse && getEnumsResponse.length > 0 && enumsObj) {
                getEnumsResponse = langSpecificEnums(getEnumsResponse, enumsObj);
              }

              return DpGetEnumsSuccess({ getEnumsResponse, sendValidatePayload, transactionId, endpoint})
            }),
            // catchError((error) => of(GetEnumsFailed({ error })))
          )
      })
    )
  )
  
  public dbSendValidate$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        DpGetEnumsSuccess,
        DpSendValidate
      ),
      mergeMap(({sendValidatePayload, transactionId, endpoint}) => {
        console.log('sendValidatePayload', sendValidatePayload); // TOdo: remove: #may6
        // return this.http.put(`${this.sendValidateUrl(endpoint)}${transactionId}`, sendValidatePayload) // Todo: revert #may6
        return of({ ...mockSendValidateRes }) // Todo: remove #may6 - mock data response
        .pipe(
          map((data) => {
            console.log(' mockSendValidateResdata', data); // TOdo: remove: #may6
            if (sendValidatePayload['destinationCountryCode'] === 'HUN') {
                data = this.checkForHungaryFields(data);
              }
              return DpSendValidateSuccess({ sendValidateResponse: data })
            }),
            // catchError((error) => of(SendValidateFailed({ error })))
          )
        })
      )
    )
  
    public dpSendCommit$ = createEffect(() =>
      this.actions$.pipe(
        ofType(
          DpSendCommit
        ),
        mergeMap(({ transactionId, locale, endpoint }) => {
          // return this.http.post(`${this.sendValidateUrl(endpoint)}${transactionId}/commit`, { userLanguage: locale}) // Todo: revert #may6
          return of({ ...mockSendCommitRes }) // Todo: remove #may6 - mock data response
            .pipe(
              map((sendCommitResponse) => {
                return DpSendCommitSuccess({ sendCommitResponse })
              }),
              // catchError((error) => of(SendCommitFailed({ error })))
            )
        })
      )
    )
    
    // Todo: Tim: Copy/paste from transaction.effcts, could be refactored
    checkForHungaryFields(data: any) {
      if (
        data &&
        !!data?.errors &&
        data?.errors[0]?.category === GFFP_FIELDS_CATEGORY
      ) {
        const isMaidenNameExists = data.errors
          .find((error: any) => error.category === GFFP_FIELDS_CATEGORY)
          ?.offendingFields?.some(
            (fieldObj: { field: any }) =>
              fieldObj.field === 'sender.additionalFamilyNames.mothersMaidenName'
          );
        if (!isMaidenNameExists) {
          data.errors[0].offendingFields.push({
            field: 'sender.additionalFamilyNames.mothersMaidenName',
          });
        }
      }
      return data;
    }
} 